/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import React, {
 ChangeEvent,
 useEffect,
 useState,
} from 'react'
import {useForm} from 'react-hook-form'
import IDropdown, {IDropdownList} from 'models/dropdown'
// import {toast} from 'react-toastify'
import Spinner from 'layout/common/Spinner'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {TextField} from 'helpers/ui-components/form/TextField'
import {Select2DropdownField} from 'helpers/ui-components/form/Select2DropdownField'
import {FileField} from 'helpers/ui-components/form/FileField'
import {DatePickerField, KTSVG} from 'helpers'
import {
 fetchProductCategoryLicense,
 fetchProductCategory,
 addProductCategoryLicense,
 updateProductCategoryLicense,
} from 'utils/api/auth/myAccountService'
import {IProductCategoryLicense} from 'models/MyAccount'
import {
 ColumnProps,
 IFileObject,
 IFormField,
} from 'models/Common'
import {toast} from 'react-toastify'
import {
 fetchDistrict,
 fetchState,
} from 'utils/api/auth/locationService'
import KTTable from 'helpers/ui-components/KTTable'
import {
 formatDateForDB,
 formatDateForDisplay,
 generateRandomString,
 getFileTypeFromFileName,
} from 'utils/helper'
import {
 handleFileChange,
 handleFileDelete,
 handleFileUpload,
} from 'utils/helpers/fileUpload'
import moment from 'moment'
import {DefaultApiResponse} from 'models/ApiResponse'
// import {ILogin} from 'models/Auth'

type IProps = {
 userId: string
 loggedInUserId: number | undefined
 type: string
 accessDetails: IFormField
}

const Index = (props: IProps) => {
 const {t} = useTranslation()
 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({})
 const [productCatLicList, setProductCatLicList] = useState<
  IProductCategoryLicense[]
 >([])
 const [loader, setLoader] = useState(false)
 const isDisabled = !props.accessDetails?.canEdit
 const [tableColList, setTableColList] = useState<
  Array<ColumnProps<IProductCategoryLicense>>
 >([])
 const [dropdownList, setDropdownList] =
  useState<IDropdownList>()
 const userId = props.userId
 const {
  register,
  control,
  setValue,
  handleSubmit,
  formState: {errors, isValid},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
 })

 const handleAddMore = () => {
  const key = generateRandomString(5)
  const dataObj: IProductCategoryLicense = {
   state: 0,
   district: 0,
   license_number: '',
   expiry_date: moment().toDate(),
   license_document: '',
   product_category: 0,
   business_group: props.type,
   business_service: props.type,
   key,
  }
  setValue(key, dataObj)
  setProductCatLicList((prevItems) => [
   ...prevItems,
   dataObj,
  ])
 }

 const getOnLoadData = async () => {
  setLoader(true)
  const stateDataList: IDropdown[] = await fetchState()
  const productCatList: IDropdown[] =
   await fetchProductCategory()
  setDropdownList((prevItems) => ({
   ...prevItems,
   stateList: stateDataList,
   productCatList,
  }))
  setLoader(false)
 }

 const getDistrictData = async (
  e: ChangeEvent<HTMLInputElement>,
  fieldName: string
 ) => {
  setValue(fieldName, '')
  if (e?.target?.value) {
   setLoader(true)
   const dataList: IDropdown[] = await fetchDistrict(
    Number(e.target.value)
   )
   const data: IDropdownList = {...dropdownList}
   data[fieldName] = dataList
   setDropdownList(data)
   setLoader(false)
  }
 }

 const renderTableData = async () => {
  setLoader(true)

  const columns: Array<
   ColumnProps<IProductCategoryLicense>
  > = [
   {
    key: 'state',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.stateName'
    ),
    className: 'min-w-[140px] w-[160px]',
    render: (_, record) => {
     return (
      <div className='text-blue-500 font-bold'>
       <Select2DropdownField
        disabled={isDisabled}
        label={''}
        required={true}
        isMultiselect={false}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 boxed-select3 relative block text-lg border-0  !rounded-none`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='!py-2 !px-2 !border-0 !rounded-none'
        control={control}
        menuPortalTarget={document.body}
        id={`${record.key}.state`}
        name={`${record.key}.state`}
        rules={{
         onChange: (e: ChangeEvent<HTMLInputElement>) => {
          void getDistrictData(e, `${record.key}.district`)
         },
        }}
        placeholder={t('helperText.selectHere')}
        data={dropdownList?.stateList ?? []}
        OptionValueKey={'id'}
        OptionLabelKey={'name'}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        errors={errors}
       />
      </div>
     )
    },
   },
   {
    key: 'district',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.districtName'
    ),
    className: 'min-w-[140px] w-[160px]',
    render: (_, record) => {
     return (
      <div className='text-blue-500 font-bold'>
       <Select2DropdownField
        disabled={isDisabled}
        label={''}
        required={true}
        isMultiselect={false}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 boxed-select3 relative block text-lg border-0  !rounded-none`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='!py-2 !px-2 !border-0 !rounded-none'
        control={control}
        menuPortalTarget={document.body}
        id={`${record.key}.district`}
        name={`${record.key}.district`}
        rules={{
         onChange: () => {
          //   void getDistrictData(e, `${record.key}.district`)
         },
        }}
        placeholder={t('helperText.selectHere')}
        data={
         dropdownList?.[`${record.key}.district`] ?? []
        }
        OptionValueKey={'id'}
        OptionLabelKey={'name'}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        errors={errors}
       />
      </div>
     )
    },
   },
   {
    key: 'business_group',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.productCategory'
    ),
    className: 'min-w-[140px] w-[160px]',
    render: (_, record) => {
     return (
      <div className='text-blue-500 font-bold'>
       <Select2DropdownField
        disabled={isDisabled}
        label={''}
        required={true}
        isMultiselect={false}
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className={`${
         isDisabled
          ? '!text-[#33393D] font-medium '
          : 'font-normal !text-[#33393D]'
        } boxed-select2 boxed-select3 relative block text-lg border-0  !rounded-none`}
        wrapperClassName='relative w-full'
        inputWrapperClassName='!py-2 !px-2 !border-0 !rounded-none'
        control={control}
        menuPortalTarget={document.body}
        id={`${record.key}.business_group`}
        name={`${record.key}.business_group`}
        rules={{
         onChange: () => {
          //   void getDistrictData(e, `${record.key}.district`)
         },
        }}
        placeholder={t('helperText.selectHere')}
        data={dropdownList?.productCatList ?? []}
        OptionValueKey={'id'}
        OptionLabelKey={'name'}
        customStyle={{
         transition: 'unset',
         boxShadow: 'unset',
         border: '0px',
         borderRadius: '0px',
         padding: '0px 0px 0px 0px',
         minHeight: 'auto',
        }}
        errors={errors}
       />
      </div>
     )
    },
   },
   {
    key: 'license_number',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.licenseNumber'
    ),
    className: 'min-w-[120px] w-[140px]',
    render: (_, record) => {
     return (
      <div className='text-blue-500 font-bold'>
       <TextField
        type='text'
        disabled={isDisabled}
        label={''}
        required={true}
        wrapperClassName={'max-w-[200px]'}
        inputWrapperClassName='!py-2 !px-2 !border-0 !rounded-none'
        className='relative text-[16px] font-medium !text-[#33393D]'
        id={`${record.key}.license_number`}
        name={`${record.key}.license_number`}
        register={register(`${record.key}.license_number`, {
         validate: {
          required: (v: string) => {
           if (v === '')
            return t('common.pleaseEnterLicenseNumber')
          },
         },
         onChange: () => {
          // checkForDependentFields(field)
         },
        })}
        placeholder={t('helperText.enterHere')}
        errors={errors}
       />
      </div>
     )
    },
   },
   {
    key: 'expiry_date',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.expiryDate'
    ),
    className: 'min-w-[120px] w-[130px]',
    render: (_, record) => {
     return (
      <div className='text-blue-500 font-bold'>
       <DatePickerField
        disabled={isDisabled}
        label={''}
        required={true}
        wrapperClassName={'max-w-[200px]'}
        inputWrapperClassName='!py-0 !px-0 !border-0 !rounded-none'
        className='relative text-[16px] font-medium !p-0 !text-[#33393D]'
        id={`${record.key}.expiry_date`}
        name={`${record.key}.expiry_date`}
        control={control}
        rules={{
         validate: {
          required: (v: string) => {
           if (v === '') return t('helperText.plsSelect')
          },
         },
         onChange: () => {
          //   void getDistrictData(e, `${record.key}.district`)
         },
        }}
        minDate={moment().toDate()}
        placeholder={t('helperText.selectHere')}
        errors={errors}
        dateFormat='dd-MM-yyyy'
       />
      </div>
     )
    },
   },
   {
    key: 'license_document',
    title: t(
     'myAccountPage.businessProfile.inputLicense.productCategoryTable.uploadDocument'
    ),
    className: 'w-[180px] max-w-[200px] min-w-[160px]',
    render: (_, record) => {
     const fieldName = `${record.key}.license_document`
     return (
      <div className='text-blue-500 font-bold max-w-[200px]'>
       <FileField
        disabled={isDisabled}
        hideUploadIcon={true}
        popupHeader={t('common.addLicense')}
        wrapperClassName='w-full max-w-[200px] min-h-[72px]'
        labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
        className='font-normal'
        required={true}
        id={fieldName}
        name={fieldName}
        register={register(fieldName, {
         validate: {
          required: (v: string) => {
           if (v === '') return t('helperText.plsSelect')
          },
         },
         onChange: async (
          e: ChangeEvent<HTMLInputElement>
         ) => {
          const res = await handleFileChange(
           e,
           uploadedFileData,
           setLoader,
           setUploadedFileData
          )
          if (res) {
           setValue(fieldName, res.filepath)
          }
         },
        })}
        placeholder={t('common.addLicense')}
        errors={errors}
        signedPhoto={
         uploadedFileData?.[fieldName]?.signedUrl
        }
        fileType={uploadedFileData?.[fieldName]?.fileType}
        fileName={uploadedFileData?.[fieldName]?.fileName}
        onFileDrop={async (file: File) => {
         const res = await handleFileUpload(
          file,
          fieldName,
          uploadedFileData,
          setLoader,
          setUploadedFileData
         )
         if (res) {
          setValue(fieldName, res.filepath)
         }
        }}
        uploadHintText={`Click to upload ${t(
         'common.addLicense'
        ).toLowerCase()} or drag & drop`}
        validFileText={t(
         'myAccountPage.businessProfile.inputLicense.validFileTypes'
        )}
       />
      </div>
     )
    },
   },
  ]
  setTableColList(columns)
  setLoader(false)
 }

 const getProductCategoryLicenseData = async () => {
  setLoader(true)
  const fileData = {...uploadedFileData}
  const dataList: IProductCategoryLicense[] =
   await fetchProductCategoryLicense(
    props.userId,
    props.type
   )
  const productData: IProductCategoryLicense[] = []
  if (dataList.length > 0) {
   const ddData: IDropdownList = {...dropdownList}
   for (const data of dataList) {
    const key: string = generateRandomString(5)
    const dataObj: IProductCategoryLicense = {...data}
    dataObj.key = key
    if (dataObj.state) {
     const districtList: IDropdown[] = await fetchDistrict(
      Number(dataObj.state)
     )
     ddData[`${key}.district`] = districtList
    }
    if (dataObj.expiry_date) {
     const expiry_date = dataObj.expiry_date
     dataObj.expiry_date = new Date(dataObj.expiry_date)
    }
    if (dataObj.license_document) {
     fileData[`${key}.license_document`] = {
      filePath: dataObj.license_document,
      signedUrl: dataObj.license_document_url ?? '',
      fileType: getFileTypeFromFileName(
       dataObj.license_document
      ),
     }
    }

    setUploadedFileData({...fileData})
    setValue(key, dataObj)
    productData.push(dataObj)
   }
   setDropdownList((prevItems) => ({
    ...prevItems,
    ...ddData,
   }))
   setProductCatLicList(productData)
  } else {
   handleAddMore()
  }
  setLoader(false)
 }

 const verifyLicence = async () => {
  setLoader(true)
  try {
   const licencesToVerify = productCatLicList
    .filter((item) => item.id && !item.is_verified)
    .map((item) => ({
     ...item,
     is_verified: true,
     expiry_date: formatDateForDB(
      typeof item.expiry_date === 'string'
       ? new Date(item.expiry_date)
       : item.expiry_date
     ),
     license_document:
      uploadedFileData?.[`${item.key}.license_document`]
       ?.filePath || item.license_document,
    }))

   if (licencesToVerify.length > 0) {
    const res = await updateProductCategoryLicense(
     licencesToVerify,
     props.userId ?? props.loggedInUserId
    )

    if (res) {
     toast.success(res.message)
     const updatedList = productCatLicList.map((item) => {
      if (licencesToVerify.find((x) => x.id === item.id)) {
       setValue(`${item.key}.is_verified`, true)
       return {...item, is_verified: true}
      }
      return item
     })
     setProductCatLicList(updatedList)
    }
   } else {
    toast.info(t('common.noLicencesToVerify'))
   }
  } catch (err) {
   toast.error(t('common.failedToVerifyLicences'))
   console.error(err)
  } finally {
   setLoader(false)
  }
 }

 async function submitFormData(formData: IFormField) {
  setLoader(true)
  const newProductData: IProductCategoryLicense[] = []
  const updatedProductData: IProductCategoryLicense[] = []
  const newRecordKeyList: string[] = []
  for (const key in formData) {
   if (formData.hasOwnProperty(key)) {
    const dataObj = formData[key]
    dataObj.expiry_date = formatDateForDB(
     dataObj.expiry_date
    )
    dataObj.license_document =
     uploadedFileData?.[`${key}.license_document`]?.filePath
    delete dataObj.key
    if (dataObj?.id) {
     updatedProductData.push(dataObj)
    } else {
     newRecordKeyList.push(key)
     newProductData.push(dataObj)
    }
   }
  }
  let res: DefaultApiResponse | null = null
  if (updatedProductData.length > 0) {
   res = await updateProductCategoryLicense(
    updatedProductData,
    userId ?? props.loggedInUserId
   )
  }
  if (newProductData.length > 0) {
   res = await addProductCategoryLicense(
    newProductData,
    props.userId ?? props.loggedInUserId
   )
   if (res) {
    const productData: IProductCategoryLicense[] = [
     ...productCatLicList,
    ]
    res.data?.map(
     (val: IProductCategoryLicense, i: number) => {
      const index = productData.findIndex(
       (product) => product.key == newRecordKeyList[i]
      )
      if (index !== -1) {
       productData[index] = {
        ...productData[index],
        ...val,
       }
       setValue(newRecordKeyList[i], productData[index])
      }
     }
    )
    setProductCatLicList(productData)
   }
  }
  if (res) {
   toast.success(res.message)
  }
  setLoader(false)
 }

 useEffect(() => {
  void getOnLoadData()
  void getProductCategoryLicenseData()
 }, [props.userId])

 useEffect(() => {
  if (dropdownList) {
   void renderTableData()
  }
 }, [dropdownList, uploadedFileData])

 return (
  <>
   {loader && <Spinner />}
   <div className='w-full'>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='w-full'>
      <div>
       <KTTable
        data={productCatLicList}
        columns={tableColList}
        headerClass='bg-[#80868C]'
        tableClass='table-fixed w-full min-w-[980px]'
       />
       <div className='-mt-2 border-[#E6EBF0] border-[0.5px] text-white  py-3 px-4 flex items-center w-full'>
        {props.accessDetails.canAdd && (
         <div
          className='flex text-[#4E83E4] text-lg font-bold items-center w-[200px] cursor-pointer'
          onClick={handleAddMore}
         >
          <KTSVG
           path={`/media/icons/plus.svg`}
           svgClassName={`w-4 h-4`}
          />
          <div>{t('common.addNewLicence')}</div>
         </div>
        )}
        {!isDisabled && (
         <div className='w-full'>
          <div className='flex items-center justify-end '>
           <Button
            type='submit'
            color='blue'
            disabled={!isValid}
            className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4] mr-1'
           >
            {t('myAccountPage.save')}
           </Button>
           <Button
            onClick={async () => verifyLicence()}
            color='blue'
            disabled={!isValid}
            className='text-center py-[9px] px-6 bg-[#4E83E4] 
                  !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
           >
            {t('myAccountPage.verify')}
           </Button>
          </div>
         </div>
        )}
       </div>
      </div>
     </div>
    </form>
   </div>
  </>
 )
}

export default Index
